/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Google single sign-on login request
 */
export interface GoogleLoginRequest {
  /**
   * Google ID token (JWT) issued for our client id
   */
  credential: string;
  /**
   * 2FA code. Required when 2FA is enabled for the user
   */
  twoFACode?: string;
}
